export const VISUALIZATION = {
  EVENT: {
    NEW_FIELD_ORDER: "saveNewFieldOrder",
    UPDATE_FIELD: "updateField",
    DELETE_FIELD: "deleteField"
  }
};

export const DEFAULT_VALUE = {
  SCHEMA: {
    type: "object",
    properties: {
      field: {} as { type: string; "x-class"?: string }
    }
  }
};
